
export const APP_VERSION = '1.0.38';
export const APP_VERSION_DEV = '1.0.26';
export const BUILD_DATE = '13-10-2026 00:53:11';
export const BUILD_NUMBER = '131020260053';
